import { Link, usePage } from "@inertiajs/react";
import type { PropsWithChildren } from "react";

import AppBetaBanner from "@/components/app-beta-banner";
import AppLogoIcon from "@/components/app-logo-icon";
import { rootPath } from "@/routes";
import type { SharedData } from "@/types";

interface AuthLayoutProps {
  name?: string;
  title?: string;
  description?: string;
}

export default function AuthSimpleLayout({
  children,
  title,
  description,
}: PropsWithChildren<AuthLayoutProps>) {
  const { show_beta_banner, banner_announcement } = usePage<SharedData>().props.ui ?? {};
  const showBanner = Boolean(show_beta_banner) || Boolean(banner_announcement);
  return (
    <>
      {showBanner && <AppBetaBanner />}
      <div className="bg-background flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className="w-full max-w-sm">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col items-center gap-4">
            <Link
              href={rootPath()}
              className="flex flex-col items-center gap-2 font-medium"
            >
              <div className="mb-1 flex size-14 items-center justify-center rounded-md">
                <AppLogoIcon className="size-14 fill-current text-[var(--foreground)] dark:text-white" />
              </div>
              <span className="sr-only">{title}</span>
            </Link>

            <div className="space-y-2 text-center">
              <h1 className="text-xl font-medium">{title}</h1>
              <p className="text-muted-foreground text-center text-sm">
                {description}
              </p>
            </div>
          </div>
          {children}
        </div>
      </div>
      </div>
    </>
  );
}
